"use client";
import React, { useState } from 'react';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import WhyChooseUsSection from './WhyChooseUsSection';
import ProcessSection from './ProcessSection';
import FAQSection from './FAQSection';
import ContactSection from './ContactSection';

export default function MovingServicesVilniusPage() {
  // State management for section visibility
  const [isHeroVisible, setIsHeroVisible] = useState(false);
  const [isServicesVisible, setIsServicesVisible] = useState(false);
  const [isWhyChooseUsVisible, setIsWhyChooseUsVisible] = useState(false);
  const [isProcessVisible, setIsProcessVisible] = useState(false);
  const [isFAQVisible, setIsFAQVisible] = useState(false);
  const [isContactVisible, setIsContactVisible] = useState(false);

  return (
    <>
      <main style={{ margin: 0, padding: 0, width: "100vw", minHeight: "100vh" }}>
        <HeroSection 
          isVisible={isHeroVisible}
          onVisibilityChange={setIsHeroVisible}
        />
        
        <ServicesSection 
          isVisible={isServicesVisible}
          onVisibilityChange={setIsServicesVisible}
        />
        
        <WhyChooseUsSection 
          isVisible={isWhyChooseUsVisible}
          onVisibilityChange={setIsWhyChooseUsVisible}
        />
        
        <ProcessSection 
          isVisible={isProcessVisible}
          onVisibilityChange={setIsProcessVisible}
        />
        
        <FAQSection 
          isVisible={isFAQVisible}
          onVisibilityChange={setIsFAQVisible}
        />
        
        <ContactSection 
          isVisible={isContactVisible}
          onVisibilityChange={setIsContactVisible}
        />

      </main>
      

    </>
  );
} 